import groupFragmentRawString from '../GroupFragment.graphql'

export const groupFragmentString = groupFragmentRawString

export type GroupFragment = {
  id: string
  name: string
}

export const isGroupFragment = (fragment: any): fragment is GroupFragment =>
  fragment &&
  typeof fragment.id === 'string' &&
  typeof fragment.name === 'string'
